import { useState, useEffect } from 'react';
import '../styles/homeNewStyles.css'
import * as Strings from '../utils/Strings'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../redux/Store';
import { getData } from '../hooks/HomeScreenHooks';
import { HomeScreenResponseModel } from '../models/HomeResponseModel';
import { Actions } from '../redux/Actions';
import { setError } from '../redux/GoodWillReducer';
import goodwillLogo from '../assets/images/icon_good_will.png'
import careerNavigator from '../assets/images/icon_career_navigator.png'
import icon_error from '../assets/images/icon_error.png'
import loadingImage from '../assets/images/icon_loading.gif'
import { BASE_URL } from '../api/ApiConstants';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import BackgroundImage from '../assets/images/slide5.jpg'
import { setClarityTag } from '../utils/ClarityUtils';
import { useStateContext } from '../context/StateContext';
import StateSelector from '../components/StateSelector';
import { CareerCenterLocationModel } from '../models/CareerCenterLocationModel';


function HomeNew() {

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const { setLocations, selectedState } = useStateContext();

    useEffect(() => {
        setClarityTag('page', 'Home');
    }, [])

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    const navigate = useNavigate();

    const dispatch = useDispatch()
    const isOnline = navigator.onLine

    const { loading, error, homeScreenData } = useSelector((state: RootState) => state.home);

    /* useEffect(() => {
        if (homeScreenData === undefined && isOnline) {
            getData(dispatch, selectedState?.id?.toString() || null)
        } else if (!isOnline) {
            dispatch(setError({ errorMessage: Strings.networkErrorMessage, operation: Actions.FETCH_DATA }))
        }
    }, []) */

    useEffect(() => {
    const loadData = async () => {
        const stateId = selectedState ? selectedState.id.toString() : null;
        if (isOnline) {
            getData(dispatch, stateId);
        } else {
            dispatch(setError({ errorMessage: Strings.networkErrorMessage, operation: Actions.FETCH_DATA }));
        }
    };
    loadData();
}, [selectedState, isOnline, dispatch]);

    useEffect(() => {
        if (homeScreenData) {
            const locationsMap = new Map<number, CareerCenterLocationModel>();
            homeScreenData.forEach(item => {
                item.careerCenterLocations?.forEach(loc => {
                    if (loc.id !== undefined && !locationsMap.has(loc.id)) {
                        locationsMap.set(loc.id, loc);
                    }
                });
            });
            const locations = Array.from(locationsMap.values());
            setLocations(locations);
        }
    }, [homeScreenData, setLocations]);

    return (
        <div>
            <div className="section-header">
                <img src={goodwillLogo} alt={''} className='logo' />
                <StateSelector />
                <div className='career-navigator-container'>
                    <img src={careerNavigator} alt={''} className='career-navigator-img' onClick={navigateToCareerNavigator} />
                </div>
            </div>
            {renderHomeScreen()}
        </div>
    );

    function getFilteredData() {
        if (!homeScreenData) return [];
        let data = homeScreenData.filter((item) => item.parentId === null);
        
        if (selectedState) {
             data = data.filter(item => 
                item.stateId === selectedState.id
            );
        }
        return data;
    }

    function renderHomeScreen() {
        if (loading) {
            return renderProgressBar()
        } else if (error) {
            return renderError()
        } else {
            return windowWidth > 768 ? renderCardWithBackground() : renderCard()
        }
    }

    function renderCarousel() {
        const data = getFilteredData();
        return (
            <div>
                <Carousel autoPlay={true} showThumbs={false} infiniteLoop={true} showStatus={false} >
                    {data?.map((item, index) =>
                        <div style={{
                            backgroundImage: `url(${BASE_URL}/${item?.image}`,
                            backgroundSize: 'cover',
                            height: '86vh',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            flexDirection: 'column',
                        }} onClick={() => onCardClick(item)}>
                            <div style={{ backgroundColor: '#000', opacity: '0.6', padding: '12px', marginBottom: '2.5%', marginLeft: '28px', marginRight: '28px', borderTopLeftRadius: '15px', borderBottomRightRadius: '15px', display: 'flex', flexDirection: 'column' }}>
                                <div className='carousel-subtitle'>{item.subTitle}</div>
                                <div className='carousel-title'>{item.title}</div>
                            </div>
                        </div>
                    )}
                </Carousel>
            </div>
        )
    }

    function renderProgressBar() {
        return (
            <div className='container-with-center-alignment'>
                <img src={loadingImage} alt={''} className='error-img' />
                <div className='loading-text'>{Strings.fetchingData}</div>
            </div>
        )
    }

    function renderError() {
        return (
            <div className='container-with-center-alignment' >
                <img src={icon_error} alt={''} className='error-img' />
                <div className='error-text' >{error ? error?.errorMessage : Strings.commonError}</div>
            </div>
        )
    }

    function renderCardWithBackground() {

        const data = getFilteredData();
        return (
            <div style={{ position: 'relative', height: '85vh', }}>
                <div style={{
                    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5)), url(${BackgroundImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    height: '55vh',
                }} />
                <div className='good-will-container' style={{ backgroundColor: 'transparent', position: 'absolute', bottom: 0, paddingBottom: '12px', paddingTop: '12pz', marginLeft: '1%' }}>
                    {data?.map((item, index) =>
                        <div className='card' key={index} onClick={() => onCardClick(item)} >
                            <img src={`${BASE_URL}/${item.image}`} alt={''} />
                            <div className='card-body'>
                                <div className='card-subtitle'>{item.subTitle}</div>
                                <div className='card-title'>{item.title}</div>
                            </div>
                        </div >
                    )
                    }
                </div>
            </div>
        )
    }

    function renderCard() {
        const data = getFilteredData();
        return (
            <div style={{ overflow: 'auto' }}>
                <div className='good-will-container'>
                    {data?.map((item, index) =>
                        <div className='card' key={index} onClick={() => onCardClick(item)} >
                            <img src={`${BASE_URL}/${item.image}`} alt={''} />
                            <div className='card-body'>
                                <div className='card-subtitle'>{item.subTitle}</div>
                                <div className='card-title'>{item.title}</div>
                            </div>
                        </div >
                    )
                    }
                </div>
            </div>
        )
    }

    function onCardClick(item: HomeScreenResponseModel) {
        navigate(`/${item.title}`, { state: { id: item.id } })
    }

    function navigateToCareerNavigator() {
        navigate('/career-navigator', { state: { from: 'Home' } })
    }
}

export default HomeNew;
